module.exports = __webpack_public_path__ + "379dfc1285ff00f8deede0f57ca3cfb3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/img/sprite_benefits_notify.png
// module id = 289
// module chunks = 0